import { providerRequestsTyped } from "@/api/(requests)/providerTyped";
import type { UUID } from "@/core/types";

export async function getPatientConsents(patientId: UUID) {
  return providerRequestsTyped.get_patient_consents({ context: { showLoader: false }, patientId });
}
